import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const PromoIcon: React.FC<IconProps> = (props) => (
  <Icon 
  width="12" 
  height="12" 
  viewBox="0 0 12 12" 
  display="block"
  {...props}>
    <path
      d="M4 6.495L5.33333 7.82833L8 5.16166M12 6.495C12 7.28293 11.8448 8.06314 11.5433 8.7911C11.2417 9.51905 10.7998 10.1805 10.2426 10.7376C9.68549 11.2948 9.02405 11.7367 8.2961 12.0383C7.56815 12.3398 6.78793 12.495 6 12.495C5.21207 12.495 4.43185 12.3398 3.7039 12.0383C2.97595 11.7367 2.31451 11.2948 1.75736 10.7376C1.20021 10.1805 0.758251 9.51905 0.456723 8.7911C0.155195 8.06314 -1.17411e-08 7.28293 0 6.495C2.37122e-08 4.9037 0.632141 3.37757 1.75736 2.25235C2.88258 1.12714 4.4087 0.494995 6 0.494995C7.5913 0.494995 9.11742 1.12714 10.2426 2.25235C11.3679 3.37757 12 4.9037 12 6.495Z"
      fill="white"
    />
  </Icon>
);
